<template>
  <v-sheet class="pre-call-alert" :color="props.color" :rounded="4">
    <v-icon icon="info" :color="props.iconColor" />
    {{ props.alert }}
  </v-sheet>
</template>
<script setup>
const props = defineProps({
  alert: {type: String},
  color: {type: String},
  iconColor: {type: String},
})
</script>
<style lang="scss" scoped>
.pre-call-alert {
  padding: $spacing-s;
  gap: $spacing-s;
  display: flex;
  flex-direction: row;
  color: $font-black-1;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
}
</style>
